import React from 'react';
import PropTypes from 'prop-types';
import BBHeading from '../Text/BBHeading';
import Link from '../../../01_atoms/Link';
import NextArrow from '../../../../public/static/icons/next-arrow.svg';
import { propTypes as linkPropTypes } from '../../../01_atoms/Link';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBFullWidthBanner = ({
  heading,
  subheading = '',
  link = null,
  behaviorSettings = null,
  uuid = null,
}) => (
  <div
    className={`bb bb-full-width-banner ${
      styles['bb-full-width-banner']
    } ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    id={uuid}
  >
    <div className={styles['bb-full-width-banner-wrapper']}>
      <BBHeading title={heading} Tag="h2" className={styles['bb-full-width-banner-heading']} />

      <div className="container">
        <div className={styles['bb-full-width-banner-subheading']}>
          <p>{subheading}</p>
        </div>
      </div>
      {link && link.nextLink && link.nextLink.url && (
        <div className={`container ${styles['bb-full-width-banner-link']}`}>
          <Link {...link.nextLink}>
            <a href={link.nextLink.url} className="analytics-bb-full-width-banner">
              {link.label}
              <span className="arrow" aria-hidden="true">
                <NextArrow />
              </span>
            </a>
          </Link>
        </div>
      )}
    </div>
  </div>
);

BBFullWidthBanner.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  link: PropTypes.shape({
    label: PropTypes.string,
    nextLink: PropTypes.shape(linkPropTypes),
  }),
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBFullWidthBanner;
